/* tslint:disable */

declare var Object: any;
export interface SFLoanRequestSF6Interface {
  "id"?: number;
}

export class SFLoanRequestSF6 implements SFLoanRequestSF6Interface {
  "id": number;
  constructor(data?: SFLoanRequestSF6Interface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFLoanRequestSF6`.
   */
  public static getModelName() {
    return "SFLoanRequestSF6";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFLoanRequestSF6 for dynamic purposes.
  **/
  public static factory(data: SFLoanRequestSF6Interface): SFLoanRequestSF6{
    return new SFLoanRequestSF6(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFLoanRequestSF6',
      plural: 'SFLoanRequestSF6s',
      path: 'SFLoanRequestSF6s',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFLoanRequestSF6.ts